import React from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";

const PrivateRoute = (props) => {
    const { component: Component, ...rest } = props;
    const { isLoggedIn } = useSelector(state => state.auth);

    const location = useLocation();

    if (isLoggedIn) {
        return <Outlet />;
    }

    const fullPathWithQuery = location.pathname + location.search;
    const params = new URLSearchParams();
    params.set("returnURL", fullPathWithQuery);

    return <Navigate to={`/login?${params.toString()}`} replace />;
}

export default PrivateRoute;






//import React, { Component } from 'react';
//import { connect, } from 'react-redux';
//import { Route, } from 'react-router-dom';
//import { withRouter } from './withRouter';

//class PrivateRoute extends Component {
//    static displayName = PrivateRoute.name;

//    constructor(props) {
//        super(props);

//        this.state = {
//            loading: false,
//        };
//    }

//    componentWillMount() {

//        if (!this.props.auth.isLoggedIn) {
//            this.props.navigate("/login");
//        }
//    }

//    render() {
//        return (
//            <Route {...this.props.rest} element={this.props.element} key={this.props.key} path={this.props.path} />
//        );
//    }
    
//}
//const mapStateToProps = (state) => {
//    return {
//        auth: state.auth,
//    };
//}

//export default connect(mapStateToProps, null)(withRouter(PrivateRoute));